import React from 'react';
import BaseIcon from './BaseIcon';

import { ReactComponent as IconPath } from 'assets/images/icons/maps-and-flags.svg';

function LocationIcon(props) {
  return <BaseIcon SVGElement={IconPath} {...props} />;
}

export default LocationIcon;
